/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import { debounce } from '@ember/runloop';
import CampaignModel from 'cio/models/campaign';
import SubjectStepModel from 'cio/models/subject-step';
import config from 'cio/config/environment';
import isDestroyed from 'cio/utils/is-destroyed';

const JOURNEY_STEP_LATENCY = config.APP.JourneyStepLatency;

interface JourneyStepDescriptionSignature {
  Element: HTMLDivElement;
  Args: {
    step: SubjectStepModel;
    campaign?: CampaignModel;
  };
}

export default class JourneyStepDescription extends Component<JourneyStepDescriptionSignature> {
  @tracked isOpen = false;
  @tracked hasPopup = false;
  @tracked container: HTMLElement | null = null;

  setIsOpen(isOpen: boolean) {
    if (!isDestroyed(this)) {
      this.isOpen = isOpen;
    }
  }

  @action
  handleInsert(el: HTMLElement) {
    this.container = el;
  }

  @action
  findAnchor() {
    return this.container?.querySelector(':scope > .cio-step-description');
  }

  @action
  open() {
    if (this.hasPopup) {
      debounce(this, this.setIsOpen, true, JOURNEY_STEP_LATENCY);
    }
  }

  @action
  close() {
    if (this.hasPopup) {
      debounce(this, this.setIsOpen, false, JOURNEY_STEP_LATENCY);
    }
  }

  @action
  onInsert() {
    this.hasPopup = true;
  }
}
